import React from 'react';
import ContactInformation from './components/ContactInformation';
import ChangePassword from './components/ChangePassword';
import DeleteAccount from './components/DeleteAccount';

export default function Profile() {
  return (
    <div className="py-4">
      <ContactInformation />
      <ChangePassword />
      <DeleteAccount />
    </div>
  );
}
